module.exports = __webpack_public_path__ + "media/country_flags/kh-39811b29.png";